<script setup>
import SignupGate from '../components/SignupGate.vue'
import Hero from '../components/Hero.vue'
import CodeExample from '../components/CodeExample.vue'
import MetricsBar from '../components/MetricsBar.vue'
import ProductGrid from '../components/ProductGrid.vue'
import HowItWorks from '../components/HowItWorks.vue'
import WaitlistForm from '../components/WaitlistForm.vue'
</script>

<template>
  <main class="bg-white">
    <SignupGate />
    <Hero />
    <CodeExample />
    <MetricsBar />
    <ProductGrid />
    <HowItWorks />
    <WaitlistForm />
  </main>
</template>
